import React from 'react'
import clsx from "clsx"
//import I18n from "i18n-js/index.js.erb"

export default class RoomTypePresenterHousekeepingTypes extends React.Component {

  constructor(props) {
    super(props)

  }

  render() {
    
    var tabClasses = clsx({
      'active': this.props.active_tab == 'housekeeping_types',
      'tab-pane': true
    })
    
    return (
      <div className={tabClasses} id="housekeeping_types">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{ marginBottom: 0 }}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6" >
                  <h3 className="panel-title">
                    {I18n.t('housekeeping_types')}
                  </h3>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="panel-body">
                {this.renderHousekeepingTypes() }
              </div>
            </div>
          </div>
        </div>
      </div>  
    )
  }

  renderHousekeepingTypes() {
    var self = this;
    if (this.props.room_type_housekeeping_types.length == 0) {
      return (
        <div className="no-records">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
    var housekeeping_types = this.props.room_type_housekeeping_types.map(function (housekeeping_type, idx) {
      return (
        <div className="row ht-row" key={idx}>
          <div className="col-md-2 name-wrapper">
            <div className="form-group">
              <label>{I18n.t('housekeeping_type')}</label>
              <div>{housekeeping_type.code} ({housekeeping_type.name})</div>
            </div>
          </div>
          <div className="col-md-3" style={{ display: "flex"}}>
            <div className="form-group">
              <label>{I18n.t('frequency')}</label>
              <div>{I18n.t(housekeeping_type.frequency) || ''}</div>
            </div>
          </div>
          <div className="col-md-3" style={{ display: "flex" }}>
            <div className="form-group">
              <label>{I18n.t('estimated_minutes')}</label>
              <div>{housekeeping_type.estimated_time || I18n.t('none')}</div>
            </div>
          </div>
          
        </div>
      )
    })

    return (
      <div className="housekeeping-types-form">
        {housekeeping_types}
      </div>
    )
  }

}